export default "__VITE_ASSET__d3718d46__"